import React from 'react'
import { Box } from '@mui/material'

const BackgroundVideo = ({video, sx}) => {
  return (
    <Box // Video Background 
        component='video' autoPlay loop muted playsInline
        src={video}
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100%',
            height:'100%',
            maxWidth: '100%',
            zIndex: '-2',
            transform: 'translate(-50%, -50%)',
            objectFit:'cover',
            objectPosition:'center',
            ...sx
        }}
      />
  )
}

export default BackgroundVideo